import { Component, Input, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-determinate-progress-bar',
  templateUrl: './determinate-progress-bar.component.html',
  styleUrls: ['./determinate-progress-bar.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class DeterminateProgressBarComponent implements OnInit {
  private _value: number;
  private _maxValue: number;
  @Input() public colorizeProgress = false;
  @Input() public titleText: string;
  @Input() public showValue = false;
  @Input() public height = 16;

  public progress = 0;
  public color = '#7DCE82';
  private colorLevels = [
    { bottom: 0, color: '#7DCE82' },
    { bottom: 80, color: '#F59100' },
    { bottom: 100, color: '#B92D00' },
  ];

  constructor() {}

  ngOnInit() {}

  @Input()
  set value(value: number) {
    this._value = value;
    this.recalculateProgress();
  }

  get value() {
    return this._value;
  }

  @Input()
  set maxValue(maxValue: number) {
    this._maxValue = maxValue;
    this.recalculateProgress();
  }

  get maxValue() {
    return this._maxValue;
  }

  private recalculateProgress() {
    this.progress = 0;
    if (this._value && this._maxValue) {
      if (this._value === 0 || this._maxValue === 0) {
        this.progress = 0;
      } else if (this._value >= this._maxValue) {
        this.progress = 100;
      } else {
        this.progress = (this._value / this._maxValue) * 100;
      }
    }
    // Set correct color if colorize chosen
    if (this.colorizeProgress && this.colorLevels) {
      let chosenColor = this.colorLevels[0].color;
      for (let i = 0; i < this.colorLevels.length; i++) {
        if (this.progress >= this.colorLevels[i].bottom) {
          chosenColor = this.colorLevels[i].color;
        }
      }
      if (chosenColor) {
        this.color = chosenColor;
      }
    }
  }
}
